/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Proposal_ContentInputs */

const en_home_proposal_content = /** @type {(inputs: Home_Proposal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop the development of the most powerful general AI systems until we know how to make them safe. This needs to happen on an international level, and it needs to happen soon.`)
};

/**
* | output |
* | --- |
* | "Stop the development of the most powerful general AI systems until we know how to make them safe. This needs to happen on an international level, and it need..." |
*
* @param {Home_Proposal_ContentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_proposal_content = /** @type {((inputs?: Home_Proposal_ContentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Proposal_ContentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_proposal_content(inputs)
});